exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Rooms[data-v-2a59874d]{background-color:red}", "", {"version":3,"sources":["/Users/madis/Documents/mobi/_web/mars/mars-demo/src/modules/Room/Room.vue"],"names":[],"mappings":"AACA,wBACE,oBAAsB,CACvB","file":"Room.vue","sourcesContent":["\n.Rooms[data-v-2a59874d] {\n  background-color: red;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2a59874d","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/Room/Room.vue
// module id = 459
// module chunks = 2